// src/components/infografia/properties/TextProperties.jsx
import React from 'react';
import { SketchPicker } from 'react-color';

const TextProperties = ({ element, onUpdate }) => {
    const props = element.propiedades || {};

    const handleChange = (field, value) => {
        onUpdate({
            propiedades: {
                ...props,
                [field]: value
            }
        });
    };

    return (
        <div className="space-y-4">
            {/* Contenido */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Contenido
                </label>
                <textarea
                    value={props.contenido || ''}
                    onChange={(e) => handleChange('contenido', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    rows={3}
                />
            </div>

            {/* Fuente */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Fuente
                </label>
                <select
                    value={props.fuente || 'Arial'}
                    onChange={(e) => handleChange('fuente', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                    <option value="Arial">Arial</option>
                    <option value="Helvetica">Helvetica</option>
                    <option value="Times New Roman">Times New Roman</option>
                    <option value="Courier New">Courier New</option>
                    <option value="Verdana">Verdana</option>
                </select>
            </div>

            {/* Tamaño */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Tamaño: {props.tamaño || 24}px
                </label>
                <input
                    type="range"
                    min="12"
                    max="200"
                    value={props.tamaño || 24}
                    onChange={(e) => handleChange('tamaño', parseInt(e.target.value))}
                    className="w-full"
                />
            </div>

            {/* Color */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Color
                </label>
                <div className="flex items-center gap-2">
                    <input
                        type="color"
                        value={props.color || '#000000'}
                        onChange={(e) => handleChange('color', e.target.value)}
                        className="w-12 h-12 border border-gray-300 rounded cursor-pointer"
                    />
                    <input
                        type="text"
                        value={props.color || '#000000'}
                        onChange={(e) => handleChange('color', e.target.value)}
                        className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>
            </div>

            {/* Alineación */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Alineación
                </label>
                <div className="flex gap-2">
                    {['left', 'center', 'right'].map((align) => (
                        <button
                            key={align}
                            onClick={() => handleChange('alineacion', align)}
                            className={`flex-1 px-3 py-2 border rounded-md ${props.alineacion === align
                                    ? 'bg-blue-500 text-white border-blue-500'
                                    : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                                }`}
                        >
                            {align === 'left' ? 'Izq' : align === 'center' ? 'Centro' : 'Der'}
                        </button>
                    ))}
                </div>
            </div>

            {/* Estilos */}
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    Estilos
                </label>
                <div className="flex gap-2">
                    <button
                        onClick={() => handleChange('negrita', !props.negrita)}
                        className={`px-4 py-2 border rounded-md ${props.negrita
                                ? 'bg-gray-800 text-white border-gray-800'
                                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                            }`}
                    >
                        <strong>B</strong>
                    </button>
                    <button
                        onClick={() => handleChange('cursiva', !props.cursiva)}
                        className={`px-4 py-2 border rounded-md ${props.cursiva
                                ? 'bg-gray-800 text-white border-gray-800'
                                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                            }`}
                    >
                        <em>I</em>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TextProperties;

